"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    text-transform: uppercase;\n    font-size: 0.7em;\n    font-weight: 600;\n    background-color: rgba(0, 0, 0, 0.1);\n    padding: ", "px ", "px;\n    box-sizing: border-box;\n    border-radius: ", "px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.Name = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject2(), theme && styled_components_1.css(_templateObject3()));
});
exports.Code = styled_components_1["default"].div(_templateObject4(), function (_ref2) {
  var theme = _ref2.theme;
  return styled_components_1.css(_templateObject5(), theme.spacing.unit * 0.5, theme.spacing.unit, theme.border.radius["default"]);
});
exports.Image = styled_components_1["default"].img(_templateObject6(), function (_ref3) {
  var theme = _ref3.theme;
  return styled_components_1.css(_templateObject7(), theme.spacing.unit * 4);
});
/* export const Rate = styled.div`
  ${({ theme }): FlattenSimpleInterpolation => css`
    color: ${theme.palette.text.secondary};
    font-weight: 400;
    margin-left: auto;
    font-size: 0.8em;
  `}
`; */